require('../../candidates/search/jv.search.url-redirect.service');
require('../../jhire/services/jv.req.search.url-redirect.service');

angular.module('jv.Dashboard.Analytics.Controller', [
   'jv.search.url-redirect.service',
    'jv.req.search.url-redirect.service'
])
.controller('jv.Dashboard.Analytics.Controller', ['$scope', 'jvDashboardAjaxService','$timeout', 'jvContextualLoadingService', '$rootScope','jvDashboardFactory', 'jvSearchUrlRedirectService', '$filter', 'jvReqSearchUrlRedirectService',
    function($scope, jvDashboardAjaxService, $timeout, jvContextualLoadingService, $rootScope,jvDashboardFactory, jvSearchUrlRedirectService, $filter, jvReqSearchUrlRedirectService) {
        var subAggregation;
        var subAggregationLevel2;
        var searchData;
        var filterKey;

        var removeSettings = function(obj) {
          for(var prop in obj) {
            if (prop === 'settings')
              {delete obj[prop];}
            else if (typeof obj[prop] === 'object')
              {removeSettings(obj[prop]);}
          }
        };

        var getAnalyticsCharts = function() {
            $scope.analyticsData = [];
            $scope.analyticsLabels = [];
            $scope.analyticsChartSeries = [];
            $scope.canSearch = true;

            var massageValue = function(value) {
                if (value.userValues) {
                    angular.forEach(value.userValues, function(value) {
                        if (value.EId) {
                            if (!value.value) {
                                value.value = value.EId;
                            }
                        }
                    });
                }
            };

            angular.forEach($scope.widgetObject.userWidgetSettings.widgetSetting, function(value) {
                if (value.settingId === 'graphType') {
                    $scope.analyticsChartType = value.subWidgetSettingUserValues[0].userValues[0].value;
                }

                massageValue(value);

                if (value.subWidgetSettingUserValues) {
                    angular.forEach(value.subWidgetSettingUserValues, function(value) {
                        angular.forEach(value.subWidgetSettingUserValues, function(value) {
                            massageValue(value);
                        });
                    });
                }
            });

            var args = angular.copy($scope.widgetObject.userWidgetSettings);

            // prepares the data for rendering in the grid.
            var massageData = function(results) {
                subAggregation = results.aggregation.subAggregation;
                var subAggregationCount = 0;
                var analyticsData = [];
                var analyticsLabels = [];
                var analyticsChartSeries = [];
                var noData = true;

                //Get the values for the legend if present
                if (results.aggregationFieldsLevel2) {
                    subAggregationLevel2 = results.aggregationFieldsLevel2;
                    angular.forEach(subAggregationLevel2, function(value) {
                        analyticsChartSeries.push(value.fieldName);
                    });
                }

                if (subAggregation && subAggregation[0] && subAggregation[0].subAggregation && subAggregationLevel2) {
                    subAggregationCount = subAggregationLevel2.length;

                    for (var i = 0; i < subAggregationCount; i++) {
                        var subAggregationArray = [];
                        angular.forEach(subAggregation, function(value, key) {
                            if (value.subAggregation[i]) {
                                subAggregationArray.push(value.subAggregation[i].count);
                            }
                            if (value.count) {
                                noData = false;
                            }
                        });
                        analyticsData.push(subAggregationArray);
                    }

                    angular.forEach(subAggregation, function(value) {
                        analyticsLabels.push($filter('truncateContentToLength')(value.fieldName, 25));
                    });
                } else {
                    angular.forEach(subAggregation, function(value) {
                        if (value.count) {
                            noData = false;
                        }
                        analyticsData.push(value.count);
                        analyticsLabels.push($filter('truncateContentToLength')(value.fieldName, 25));
                    });
                }

                //Check if no data is present.
                $scope.analyticsNoData = noData;
                searchData = results.searchPayload;
                if (!searchData) {
                    $scope.canSearch = false;
                }
                $scope.analyticsData = angular.copy(analyticsData);
                $scope.analyticsLabels = angular.copy(analyticsLabels);
                $scope.analyticsChartSeries = angular.copy(analyticsChartSeries);
            };

            var _callback = function(results) {
                if (results && results.aggregation && results.aggregation.subAggregation) {
                    massageData(results);
                    $scope.lastUpdated = results.lastUpdated;
                    jvContextualLoadingService.hide($scope.widgetObject.widgetId);
                }
            };

            jvContextualLoadingService.show($scope.widgetObject.widgetId);

            /*
            Making sure we send refresh true for new widget creating flow
            Cannot set refresh true in the REFRESH_WIDGET emit callback since the controller gets re-initialized for a newly added widget.
            Hence storing this in the factory
            */
            if($scope.refresh || jvDashboardFactory.isNewlyAddedWidget($scope.widgetObject) ){
                args.refresh = true;
            }

            removeSettings(args);

            args.widgetId = $scope.widgetObject.widgetId;

            if ($scope.widgetObject.mainType === 'ApplicationAnalytics') {
                jvDashboardAjaxService.applicationAnalytics(args, _callback);
            } else {
                jvDashboardAjaxService.requisitionAnalytics(args, _callback);
            }
        };

        var keyToMethodMap = {
            appliedDate: {
                method: 'setApplicationDate',
                type: 'date'
            },
            lastUpdated: {
                method: 'setLastUpdated',
                type: 'date'
            },
            createdDate: {
                method: 'setCreatedDate',
                type: 'date'
            },
            closedDate: {
                method: 'setClosedDate',
                type: 'date'
            },
            filledDate: {
                method: 'setFilledDate',
                type: 'date'
            },
            openDate: {
                method: 'setOpenDate',
                type: 'date'
            },
            category: {
                method: 'setCategory',
                type: 'name'
            },
            companies: {
                method: 'setCompany',
                type: 'name'
            },
            department: {
                method: 'setDepartment',
                type: 'name'
            },
            region: {
                method: 'setRegion',
                type: 'name'
            },
            jobLocation: {
                method: 'setJobLocation',
                type: 'name'
            },
            jobTypeId: {
                method: 'setJobType',
                type: 'name'
            },
            jobs: {
                method: 'setRequisitionType',
                type: 'id'
            },
            workflowStateId: {
                method: 'setWorkflow',
                type: 'id'
            },
            jobStatus: {
                method: 'setJobStateIds',
                type: 'name'
            },
            sourceId: {
                method: 'setSourceObj',
                type: 'id'
            },
            hiringManagers: {
                method: 'setHiringManagers',
                type: 'name'
            },
            recruiters: {
                method: 'setRecruiters',
                type: 'name'
            },
            postingType: {
                method: 'setPostingType',
                type: 'name'
            }
        };

        var applyClickabilitySelections = function(searchData, level1Object, level2Object) {
            var aggregationField = searchData.aggregationFields;
            if (aggregationField && aggregationField.length) {
                var subAggregationFields = aggregationField[0].subFacets;
                if (level1Object) {
                    filterKey = keyToMethodMap[aggregationField[0].searchId];
                    if (filterKey && (filterKey.type === 'name' || filterKey.type === 'id')) {
                        searchData[aggregationField[0].searchId] = {
                            value: level1Object.fieldId,
                            name: level1Object.fieldName
                        };
                    } else {
                        searchData[aggregationField[0].searchId] = level1Object.fieldId;
                    }
                }
                if (level2Object) {
                    if (subAggregationFields && subAggregationFields.length) {
                        filterKey = keyToMethodMap[subAggregationFields[0].searchId];
                        if (filterKey && filterKey.type === 'name') {
                            searchData[subAggregationFields[0].searchId] = {
                                value: level2Object.fieldId,
                                name: level2Object.fieldName
                            };
                        } else {
                            searchData[subAggregationFields[0].searchId] = level2Object.fieldId;
                        }
                    }
                }
            }
        };

        var createSearchObjectAndRedirect = function(urlRedirectService, searchData, level1Object, level2Object) {
            // We cannot click if others is selected.
            if (level1Object.fieldId === 'others' || level2Object && level2Object.fieldId === 'others') {
                return;
            }
            urlRedirectService.reset();
            applyClickabilitySelections(searchData, level1Object, level2Object);

            angular.forEach(searchData, function(value, key) {
                filterKey = keyToMethodMap[key];
                if (filterKey && value) {
                    if (filterKey.type === 'id') {
                        if (angular.isArray(value)) {
                            angular.forEach(value, function(val) {
                                urlRedirectService[filterKey.method](val.value);
                            });
                        } else {
                            if (typeof value === 'object') {
                                urlRedirectService[filterKey.method](value.value);
                            } else {
                                urlRedirectService[filterKey.method](value);
                            }

                        }
                    } else if (filterKey.type === 'name') {
                        if (angular.isArray(value)) {
                            angular.forEach(value, function(val) {
                                urlRedirectService[filterKey.method](val.value, val.name);
                            });
                        } else {
                            urlRedirectService[filterKey.method](value.value, value.name);
                        }
                    } else if (filterKey.type === 'date') {
                        if (angular.isArray(value)) {
                            angular.forEach(value, function(val) {
                                urlRedirectService[filterKey.method](val.from, val.to);
                            });
                        } else {
                            urlRedirectService[filterKey.method](value.from, value.to);
                        }
                    }
                }
            });
            urlRedirectService.redirect();
        };

        $scope.chartClick = function(level1Index, level2Index, series) {
            if (!$scope.canSearch) {
                return;
            }

            var level1Object;
            var level2Object;

            level1Object = subAggregation[level1Index];
            if (series) {
                level2Object = subAggregationLevel2[level2Index];
            }

            if ($scope.widgetObject.mainType === 'ApplicationAnalytics') {
                createSearchObjectAndRedirect(jvSearchUrlRedirectService, searchData, level1Object, level2Object);
            } else {
                createSearchObjectAndRedirect(jvReqSearchUrlRedirectService, searchData, level1Object, level2Object);
            }
        };

        $rootScope.$on('REFRESH_WIDGET', function(event,widgetData) {
            if(widgetData && $scope.widgetObject.widgetId === widgetData.widgetId){
                 //invalidate cache and fetch data from DB
                $scope.lastUpdated = '';
                $scope.refresh = true;
                getAnalyticsCharts();
            }
        });

        getAnalyticsCharts();
    }
]);
